import SoundcloudWidget from 'soundcloud-widget'

const Soundcloud = target => {
  const initSoundcloud = el => {
    const id = el.dataset.id
    el.querySelector('iframe').id = id
    const widget = new SoundcloudWidget(id)
    const playBtn = el.querySelector('.audio-player__toggle')
    const progressContainer = el.querySelector('.audio-player__timeline')
    var progressBar = el.querySelector('.audio-player__progress')

    widget.on(SoundcloudWidget.events.PLAY, () => {
      el.classList.add('audio-player--playing')
    })

    widget.on(SoundcloudWidget.events.PAUSE, () => {
      el.classList.remove('audio-player--playing')
    })

    widget.on(SoundcloudWidget.events.PLAY_PROGRESS, progress => {
      const maxWidth = progressContainer.offsetWidth
      const position = progress.relativePosition
      const newWidth = Math.floor(maxWidth * position)

      progressBar.style.width = newWidth + 'px'
    })

    playBtn.addEventListener('click', () => {
      widget.toggle()
    })

    progressContainer.addEventListener('click', event => {
      const el = progressContainer
      const width = el.offsetWidth
      const rect = el.getBoundingClientRect()
      const position = event.clientX - rect.left + document.body.scrollLeft
      const percent = position / width

      widget.getDuration().then(duration => {
        const newPosition = Math.floor(duration * percent)

        widget.seekTo(newPosition)
      })
    })

    widget.on(SoundcloudWidget.events.READY,() => {
      el.classList.remove('audio-player--loading')
    })
  };


  $('body').find(target)
    .each((_, el) => {
      initSoundcloud(el);
    });
}

export default Soundcloud


// WEBPACK FOOTER //
// ./scripts/components/Soundcloud.js